import { useMutation, useQuery } from '@tanstack/react-query'

import {
  activate,
  fetchOneByActivationCode,
  lookupOrder,
  checkout,
} from 'services/orders'

const KEY = 'orders'

export function useOrderByActivationCode(activationCode?: string) {
  return useQuery(
    [KEY, activationCode],
    () => {
      if (activationCode) {
        return fetchOneByActivationCode(activationCode)
      }
    },
    {
      enabled: !!activationCode,
    },
  )
}

export function useFetchOrderByActivationCode() {
  return useMutation(fetchOneByActivationCode)
}

export function useLookupOrder() {
  return useMutation(lookupOrder)
}

export function useActivateOrder() {
  return useMutation(activate)
}

export function useCheckout() {
  return useMutation(checkout)
}
